import { Box, Skeleton } from '@mui/material';
import React from 'react';

const PromptFormSkeleton = () => {
  return (
    <form
      style={{
        display: 'flex',
        flexGrow: 1,
        textAlign: 'left',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '24px 24px 0 24px',
          gap: '10px',
          flexGrow: 1,
          overflowY: 'auto',
          maxHeight: 'calc(100vh - 300px)',
        }}
      >
        {/* Title */}
        <Skeleton variant="text" width="50%" height={40} />

        {/* Description */}
        <Skeleton variant="text" width="80%" height={120} />

        {/* Prompt editor label */}
        <Skeleton variant="text" width="30%" height={30} />
        <Skeleton variant="rectangular" width="100%" height={200} />
        <Skeleton variant="text" width="60%" height={20} />

        {/* Tags */}
        <Skeleton variant="text" width="30%" height={30} />
        <Skeleton variant="rectangular" width="100%" height={40} />
        <Skeleton variant="text" width="70%" height={20} />

        {/* Tools */}
        <Skeleton variant="text" width="30%" height={30} />
        <Skeleton variant="rectangular" width="100%" height={40} />
      </Box>

      {/* Footer */}
      <Box
        sx={{
          display: 'flex',
          height: '80px',
          alignItems: 'center',
          justifyContent: 'end',
          gap: 2,
          paddingRight: 2,
          borderTop: '1px solid #ddd',
        }}
      >
        {[...Array(3)].map((_, i) => (
          <Skeleton key={i} variant="rectangular" width={100} height={36} />
        ))}
      </Box>
    </form>
  );
};

export default PromptFormSkeleton;
